import React from "react";
import { connect } from "react-redux";

import { doGetSetting, doUpdateSetting, doUpdateBrandSetting } from "./stores/thunk";

export default Component => {
  class Container extends React.Component {
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state, props) {
    const { match } = props;
    const params = match.params;
    return {
      isFetching: state.setting.isFetching,
      setting: state.setting.setting,
      settingType: params.settingType,
      currentUser: state.auth.user,
    };
  }

  return connect(mapStateToProps, {
    doGetSetting,
    doUpdateSetting,
    doUpdateBrandSetting,
  })(Container);
};
